import { SUPPORT_TICKET_FORM_URL } from 'Constants/env';
import { REPORT_ISSUE_REACHABILITY_TIMEOUT_MS } from 'Modules/reportIssue/index.constants';

/**

* Checks whether the report issue form host is reachable before opening the modal.
*
* @remarks
* This check helps avoid opening the report issue modal when the
* embedded form is unlikely to load. Unlike `navigator.onLine`, this check
* verifies connectivity to the form host itself.
*
* The request does not need to read the response, so no-cors is used. The
* check returns false when the request fails or exceeds the configured
* timeout.
*
* @returns true if the form host is reachable within the configured timeout;
* otherwise, false.
*/
export const checkFormReachable = async (): Promise<boolean> => {
  const controller = new AbortController();
  const timer = window.setTimeout(
    () => controller.abort(),
    REPORT_ISSUE_REACHABILITY_TIMEOUT_MS
  );

  try {
    await fetch(SUPPORT_TICKET_FORM_URL, {
      method: 'GET',
      mode: 'no-cors',
      cache: 'no-store',
      signal: controller.signal,
    });
    return true;
  } catch {
    return false;
  } finally {
    window.clearTimeout(timer);
  }
};